/**
 * @flow
 * @relayHash 5822d0b829a73aa90c8fc00a0e581bf2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type confirmAccountInput = {
  clientMutationId?: ?string,
  email: string,
};
export type confirmAccountMutationVariables = {|
  input: confirmAccountInput
|};
export type confirmAccountMutationResponse = {|
  +confirmAccount: {|
    +clientMutationId: ?string,
    +response: string,
  |}
|};
export type confirmAccountMutation = {|
  variables: confirmAccountMutationVariables,
  response: confirmAccountMutationResponse,
|};
*/


/*
mutation confirmAccountMutation(
  $input: confirmAccountInput!
) {
  confirmAccount(input: $input) {
    clientMutationId
    response
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "confirmAccountInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "confirmAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "confirmAccountInput!"
      }
    ],
    "concreteType": "confirmAccountPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "response",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "confirmAccountMutation",
  "id": null,
  "text": "mutation confirmAccountMutation(\n  $input: confirmAccountInput!\n) {\n  confirmAccount(input: $input) {\n    clientMutationId\n    response\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "confirmAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "confirmAccountMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bba88ede5724a8966e424f2e13ad2b60';
module.exports = node;
